export default __webpack_public_path__ + "static/undraw_medical_care_movn-b7ced35d056db5a11bb7132e991da238.png";